import React from 'react'
import styled from 'styled-components'
import posed from 'react-pose'
import PropTypes from 'prop-types'

const Animation = posed.div({
  hasError: {
    applyAtStart: { display: 'block' },
    height: 'auto',
    opacity: 1,
    staggerChildren: 50
  },
  isValid: {
    applyAtEnd: { display: 'none' },
    height: 0,
    opacity: 0
  }
})

const Text = posed.div({
  hasError: {
    opacity: 1
  },
  isValid: {
    opacity: 0
  }
})

const StyledErrorLine = styled.div`
  margin: ${({ margin }) => margin};
  color: ${({ theme }) => theme.colors.error};
  font-family: ${({ theme }) => theme.fonts.avenirNextMedium};
  font-size: ${({ fontSize }) => fontSize};
  text-align: ${({ textAlign = 'left' }) => textAlign};
`

class ErrorText extends React.Component {
  constructor(props) {
    super(props)
    const { error } = props
    this.state = {
      pose: error ? 'hasError' : 'isValid',
      error
    }
  }

  // Necessary to keep error to fade out when it disappears
  static getDerivedStateFromProps(nextProps, prevState) {
    const pose = nextProps.error ? 'hasError' : 'isValid'
    const error = nextProps.error || prevState.error
    return { pose, error }
  }

  render() {
    const { pose, error } = this.state
    const { fontSize, margin, textAlign } = this.props
    return (
      <Animation pose={pose}>
        <Text>
          <StyledErrorLine margin={margin} fontSize={fontSize} textAlign={textAlign}>
            {error}
          </StyledErrorLine>
        </Text>
      </Animation>
    )
  }
}

ErrorText.defaultProps = {
  fontSize: '13px',
  margin: '5px 0 5px 0'
}

ErrorText.propTypes = {
  fontSize: PropTypes.string,
  margin: PropTypes.string
}

export default ErrorText
